// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"753":"b345955c","2910":"c995dbcb","5390":"1dc0eefb","8363":"4526f157","8885":"31d6cfe0"}[chunkId] + ".chunk.css";
};